import { ShortList } from '@/components/CategorySections/ExperienceType';
import { Currency } from '@/contexts/currencyContext';
import { Experience, ExperienceTranslation } from '@/services/experienceTypes';
import { ShortListMedia } from '@/types/Experience';

const SHORTLIST_FILTER = 'medium_3-2';

// Cover media to store in the shortlist. Only the filter the shortlist renders
// is kept, so localStorage stays small.
export const toShortListMedia = (
  media: ShortListMedia | null | undefined,
): ShortListMedia | string => {
  if (!media) return '';

  return {
    id: media.id,
    path: media.path,
    filename: media.filename,
    mediaFilters: (media.mediaFilters ?? [])
      .filter(({ name }) => name === SHORTLIST_FILTER)
      .map(({ name, url }) => ({ name, url })),
  };
};

export const toggleExperienceShortlist = (
  exp: Experience,
  lang: string,
  favourites: ShortList[],
  setFavourites: (data: ShortList[]) => void,
  inShortList: boolean,
  currency: Currency,
) => {
  const translation = exp.experienceTranslation.find((item) => {
    if (item.locale === lang) {
      return item;
    }
  }) as ExperienceTranslation;

  const titleSlugs = exp.experienceTranslation.map((item) => ({
    [item.locale]: item.slug,
    title: item.title,
  }));

  const coverMedia = exp.media.find((m) => m.type === 'cover') ?? exp.media[0];

  let firstPrice = null;

  exp.optionMaps.some((option) => {
    const price = option.prices.find((price) => price.price);
    if (price) {
      firstPrice = price.price;
      return true;
    }
  });

  const shortListInfos: ShortList = {
    id: exp.id,
    title: translation.title,
    titleSlugs: titleSlugs,
    categoryId: exp.macroCategory.id,
    media: toShortListMedia(coverMedia),
    zone: {
      code: exp.zone ? exp.zone.code : '',
    },
    price: Number(firstPrice),
    currency: currency.value,
    city: exp.city,
    duration: exp.duration,
    languagens: exp.languages,
    minGuests: exp.minParticipants,
    maxGuests: exp.maxParticipants,
  };

  if (inShortList) {
    const updatedFavourites = favourites.filter((item) => item.id !== exp.id);
    setFavourites(updatedFavourites);
    localStorage.setItem('experience', JSON.stringify(updatedFavourites));
  } else {
    const updatedFavourites = [...favourites, shortListInfos];
    setFavourites(updatedFavourites);
    localStorage.setItem('experience', JSON.stringify(updatedFavourites));
  }
};
